import { Text } from 'bold-ui'
import { CustomSelectFieldProps, SelectField } from 'components/form'
import { CategoriaSubstanciaAlergia } from 'graphql/types.generated'
import { categoriaAlergiaRecord } from 'view/atendimentos/detail/soap/aside/types/AlergiaModel'

export type CategoriaSubstanciaAlergiaSelectModel = CategoriaSubstanciaAlergia

type CategoriaSubstanciaAlergiaSelectFieldProps = CustomSelectFieldProps<CategoriaSubstanciaAlergiaSelectModel>

const itemToString = (item: CategoriaSubstanciaAlergiaSelectModel) => item && categoriaAlergiaRecord[item].descricao

const renderItem = (item: CategoriaSubstanciaAlergiaSelectModel) => (
  <Text fontWeight='bold'>{item && categoriaAlergiaRecord[item].descricao}</Text>
)

const sortedItems = Object.values(CategoriaSubstanciaAlergia).sort((a, b) =>
  itemToString(a).localeCompare(itemToString(b))
)

export function CategoriaSubstanciaAlergiaSelectField(props: CategoriaSubstanciaAlergiaSelectFieldProps) {
  return (
    <SelectField<CategoriaSubstanciaAlergiaSelectModel>
      itemToString={itemToString}
      renderItem={renderItem}
      items={sortedItems}
      {...props}
    />
  )
}
